// extracted by mini-css-extract-plugin
module.exports = {"linkedGoalsTooltip":"_3BDBAfy5nm4K-mL0zGmEuX","createLinkedGoal":"_2GB_DJMzbqQIFeriC-22uO"};